import React, { useState, useEffect } from 'react';
import {jwtDecode} from 'jwt-decode';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Verificacion from '../../components/Verificacion';
import Suspendido from '../../components/Suspendido';
import AdminPrePanel from './admin/AdminPrePanel';
import MensajePanel from '../../warnings/MensajePanel';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CryptoJS from 'crypto-js';
import BASE_URL from '../../config/config';
import FotoPerfil from '../../components/ui/FotoPerfil';
import FiltroBusqueda from '../../components/ui/FiltroBusqueda';
import Loader from '../../components/Loader';
import NuevasFeatures from '../../warnings/NuevasFeatures';

const Dashboard = () => {
    const departamentos = [
      { value: 'no_especificado', label: 'Sin Especificar' },
      { value: 'diseno', label: 'Diseño' },
      { value: 'marketing', label: 'Marketing' },
      { value: 'desarrollo', label: 'Desarrollo' },
      { value: 'redes_sociales', label: 'Redes Sociales' }
    ];
  const [showPass, setShowPass] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [minimoTiempoCumplido, setMinimoTiempoCumplido] = useState(false); // ⬅️ nuevo
  const [cantidadTickets, setCantidadTickets] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [activeTab, setActiveTab] = useState('historial');
  const [currentPage, setCurrentPage] = useState(1);
  const [ticketsPerPage, setTicketsPerPage] = useState(5);
  const [searchText, setSearchText] = useState('');
  const [selectedDept, setSelectedDept] = useState('');
  const [dashboardContent, setDashboardContent] = useState('dashboard');
  const [usuarioInfo, setUsuarioInfo] = useState(null);
  const token = localStorage.getItem('AuthToken');

  const tokenInfo = token ? jwtDecode(token) : {};
  const navigate = useNavigate();

  // Perfil states
  const [nombre, setNombre] = useState(tokenInfo.nombre || '');
  const [apellidos, setApellidos] = useState(tokenInfo.apellidos || '');
  const [email, setEmail] = useState(tokenInfo.email || '');
  const [telefono, setTelefono] = useState(tokenInfo.telefono || '');
  const [contrasena, setContrasena] = useState('');
  const [webs_del_cliente, setWebs_del_cliente] = useState(tokenInfo.webs_del_cliente || '');

  const encryptPassword = password => CryptoJS.MD5(password).toString();

  const handleLogout = () => {
    localStorage.removeItem('AuthToken');
    navigate('/iniciar-sesion', { replace: true });
    window.location.reload();
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };

  const handleLinkClick = () => window.scrollTo({ top: 0 });

  const handleEditProfile = () => navigate('/dashboard/editar-perfil');
  const handleGoBack = () => setDashboardContent('dashboard');

  // Loader mínimo de 1s (como en el resto)
  useEffect(() => {
    const t = setTimeout(() => setMinimoTiempoCumplido(true), 1000);
    return () => clearTimeout(t);
  }, []);

  // Fetch cantidad de tickets
  useEffect(() => {
    const fetchCantidadTickets = async () => {
      try {
        const resp = await axios.get(`${BASE_URL}/tickets/cantidad/${tokenInfo.usuario}`);
        if (resp.status === 200) setCantidadTickets(resp.data.cantidad);
      } catch (err) {
        console.error('Error al obtener la cantidad de tickets:', err);
      }
    };
    if (tokenInfo.usuario) fetchCantidadTickets();
  }, [tokenInfo.usuario]);

  // Fetch tickets
  useEffect(() => {
    const fetchTickets = async () => {
      setIsLoading(true);
      try {
        const resp = await axios.get(
          `${BASE_URL}/tickets/total/${tokenInfo.usuario}?page=${currentPage}&limit=${ticketsPerPage}`
        );
        if (resp.status === 200) {
          const sorted = resp.data.tickets.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setTickets(sorted);
          filterTickets(sorted);
        }
      } catch (err) {
        console.error('Error al obtener los tickets:', err);
      } finally {
        setIsLoading(false);
      }
    };

    if (activeTab === 'historial' && tokenInfo.usuario) fetchTickets();
  }, [activeTab, currentPage, ticketsPerPage, tokenInfo.usuario]);

  // Filtrado
  const filterTickets = list => {
    const filtered = list.filter(
      ticket =>
        (ticket.asunto.toLowerCase().includes(searchText.toLowerCase()) ||
          ticket.identificador.toString().includes(searchText)) &&
        (selectedDept === '' || ticket.dpto.toLowerCase() === selectedDept.toLowerCase())
    );
    setFilteredTickets(filtered);
  };

  useEffect(() => filterTickets(tickets), [searchText, tickets, selectedDept]);

  // Paginación
  const totalPages = Math.ceil(filteredTickets.length / ticketsPerPage);
  const indexOfLast = currentPage * ticketsPerPage;
  const indexOfFirst = indexOfLast - ticketsPerPage;
  const currentTickets = filteredTickets.slice(indexOfFirst, indexOfLast);

  // Fetch usuario info
  useEffect(() => {
    const fetchUsuarioInfo = async () => {
      try {
        const resp = await axios.get(
          `${BASE_URL}/usuario/info/${tokenInfo.usuario}`,
          { headers: { Authorization: token } }
        );
        setUsuarioInfo(resp.data.usuario);
      } catch (err) {
        console.error('Error al obtener info de usuario:', err);
      }
    };
    if (tokenInfo.usuario) fetchUsuarioInfo();
  }, [tokenInfo.usuario, token]);

  // Loader fullscreen (antes de renderizar contenido)
  const debeMostrarLoader =
    !minimoTiempoCumplido ||
    (dashboardContent === 'dashboard' && tokenInfo.role !== 'admin' && tokenInfo.role !== 'tecnico' && isLoading);

  if (debeMostrarLoader) {
    return (
      <div className="loader-fullscreen">
        <Loader />
      </div>
    );
  }

  if (tokenInfo.estado === 'verificar') return <Verificacion />;
  if (tokenInfo.estado === 'suspendido') return <Suspendido />;
  
  const handleSaveProfile = async () => {
    let encryptedPassword = contrasena ? encryptPassword(contrasena) : '';
    const updatedData = {
      nombre,
      apellidos,
      email,
      telefono,
      ...(contrasena && { contrasena: encryptedPassword }),
      webs_del_cliente,
    };
    try {
      const response = await axios.put(
        `${BASE_URL}/usuario/update/${tokenInfo.usuario}`,
        updatedData,
        { headers: { Authorization: token } }
      );
      if (response.status === 200) {
        toast.success('Perfil actualizado con éxito.');
        handleLogout();
      } else {
        toast.error('Hubo un problema al actualizar el perfil.');
      }
    } catch (error) {
      console.error('Error al actualizar el perfil:', error);
      toast.error('Ocurrió un error al actualizar el perfil.');
    }
  };

  const renderContent = () => {
    return (
      <>
        <NuevasFeatures/>
        <MensajePanel />
        {(tokenInfo.role === 'admin' || tokenInfo.role === 'tecnico') ? (
          <AdminPrePanel />
        ) : (
          <div className="tabcontent">
            <div className='grid-historial'>
              <div className="texto-intro-dashboard">
                <h1>¡Hola, {tokenInfo.nombre}!</h1>
                <p>Nos alegramos de verte de nuevo por aquí. Consulta tus tickets y habla con un técnico en tiempo real.</p>
              </div>
              <FiltroBusqueda
                value={searchText}
                onChange={setSearchText}
                placeholder="Búsqueda por identificador o asunto..."
                showSelect={true}
                selectOptions={departamentos}
                selectValue={selectedDept}
                onSelectChange={setSelectedDept}
                selectPlaceholder="Todos los departamentos"
                className="filtro-tickets"
              />

              {/* ⚠️ Quitamos el loader inline: el fullscreen ya cubre esta fase */}
              <div className="overflow-tabla">
                <div className='panel-tickets'>
                  <div className="ticket-list-header repeat-cliente">
                    <p>Identificador</p>
                    <p>Asunto</p>
                    <p>Estado</p>
                    <p>Departamento</p>
                    <p>Prioridad</p>
                    <p>Fecha</p>
                    <p>Asignado a</p>
                  </div>
                  <div className="tickets-list">
                    {filteredTickets.length === 0 ? (
                      <div className="no-tickets">¡No tienes tickets creados todavía!</div>
                    ) : (
                      currentTickets.map(ticket => (
                        <Link
                          key={ticket.identificador} // clave estable
                          className='link-ticket'
                          to={`/ticket/${ticket.identificador}`}
                          onClick={handleLinkClick}
                        >
                          <div className="ticket-item repeat-cliente">
                            <div className="ticket-field id">#{ticket.identificador}</div>
                            <div className="ticket-field asunto">
                              {ticket.asunto.split(' ').slice(0,5).join(' ')}
                              {ticket.asunto.split(' ').length > 5 ? '...' : ''}
                            </div>
                            <div className="ticket-field estado">
                              {ticket.estado_del_ticket === 'abierto' && <p className='abierto'>Abierto</p>}
                              {ticket.estado_del_ticket === 'cerrado' && <p className='cerrado'>Cerrado</p>}
                              {ticket.estado_del_ticket === 'retenido' && <p className='retenido'>Retenido</p>}
                            </div>
                            <div className="ticket-field dpto">
                              {ticket.dpto === 'no_especificado' && <p className='no-especificado'>Sin especificar</p>}
                              {ticket.dpto === 'desarrollo' && <p className='desarrollo'>Desarrollo</p>}
                              {ticket.dpto === 'diseno' && <p className='diseno'>Diseño</p>}
                              {ticket.dpto === 'marketing' && <p className='marketing'>Marketing</p>}
                              {ticket.dpto === 'redes_sociales' && <p className='redes-sociales'>Redes Sociales</p>}
                            </div>
                            <div className="ticket-field prioridad">
                              {ticket.prioridad === 'no_urgente' && <p className='sin-prioridad'>No urgente</p>}
                              {ticket.prioridad === 'urgente' && <p className='alta'>Urgente</p>}
                            </div>
                            <div className="ticket-field fecha">{new Date(ticket.createdAt).toLocaleDateString()}</div>
                            <div className="ticket-field asignado">
                              {ticket.usuario_encargado === 'sin_asignar' ? (
                                <div className='asignado'><img src="/images/sin_asignar.svg" alt="Sin asignar" /><p>Sin asignar</p></div>
                              ) : (
                                <div className='asignado'><img src="/images/asignado.svg" alt={ticket.usuario_encargado} /><p>@{ticket.usuario_encargado}</p></div>
                              )}
                            </div>
                          </div>
                        </Link>
                      ))
                    )}
                  </div>
                  {filteredTickets.length > ticketsPerPage && (
                    <div className="pagination paginacion-cliente">
                      <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>Anterior</button>
                      <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>Siguiente</button>
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <main className='site-width'>
      <div className="dashboard-grid">
        <div className='profile-and-menu'>
          <div className='profile'>
            <div className="profile-card">
              <FotoPerfil />

              <div className="profile-info">
                {tokenInfo.nombre && tokenInfo.apellidos && (
                  <h3 className='profile-name'>{tokenInfo.nombre} {tokenInfo.apellidos}</h3>
                )}

                
                {/* Usuario en estilo @username debajo */}
                {tokenInfo.usuario && (
                  <p className='profile-username'>@{tokenInfo.usuario}</p>
                )}

                {/* Rol + Departamento en un solo contenedor */}
                {usuarioInfo && (usuarioInfo.role === 'admin' || usuarioInfo.role === 'tecnico') && (
                  <div className='profile-meta'>
                    <span className={usuarioInfo.role === 'admin' ? 'role-badge admin' : 'role-badge tecnico'}>
                      {usuarioInfo.role === 'admin' ? 'Administrador' : 'Técnico'}
                    </span>
                    <span className='dpto-badge'>
                      {usuarioInfo.dpto_tecnico === 'desarrollo' ? 'Desarrollo' : 
                      usuarioInfo.dpto_tecnico === 'marketing' ? 'Marketing' : 
                      usuarioInfo.dpto_tecnico === 'diseno' ? 'Diseño' : 
                      usuarioInfo.dpto_tecnico === 'redes_sociales' ? 'RRSS' : 
                      'Todos los dptos.'
                      }
                    </span>
                  </div>
                )}

              </div>
            </div>
            <div className="profile-actions">
              <button className='edit-profile' onClick={handleEditProfile}>Editar perfil</button>
              <button className='logout' onClick={handleLogout}><img src="/images/cerrar-sesion.svg" alt="Logout" /><p>Salir</p></button>
            </div>
          </div>

          <div className="dashboard-stats">
              <div className="bloque-secciones">
              {/* Bloque de administración eliminado según petición del usuario */}
              {tokenInfo.role !== 'admin' && tokenInfo.role !== 'tecnico' && <Link to="/dashboard/proyectos"><div className="bloque-seccion"><p>Mis proyectos</p><img src="/images/website.svg" alt="Proyectos" /></div></Link>}
              <Link to="/dashboard/servicios" onClick={handleLinkClick}><div className="bloque-seccion"><p>Mis servicios</p><img src="/images/marque-el-circulo.svg" alt="Servicios" /></div></Link>
              <Link to="https://agenciaadhoc.com/reportes" target="_blank"><div className="bloque-seccion"><p>Reportar un error</p><img src="/images/exclamacion.svg" alt="Vota mejoras" /></div></Link>

              {/* Accesos administrativos: mostrar solo a administradores */}
              {tokenInfo.role === 'admin' && (
                <>
                  <Link to="/dashboard/equipos" onClick={handleLinkClick}><div className="bloque-seccion"><p>Equipos informáticos</p><img src="/images/computadora.svg" alt="Equipos" /></div></Link>
                  <Link to="/dashboard/notificaciones" onClick={handleLinkClick}><div className="bloque-seccion"><p>Gestor de notificaciones</p><img src="/images/campana.svg" alt="Notificaciones" /></div></Link>
                  <Link to="/dashboard/ajustes-del-sistema" onClick={handleLinkClick}><div className="bloque-seccion"><p>Ajustes del sistema</p><img src="/images/ajustes.svg" alt="Ajustes" /></div></Link>
                </>
              )}
              
            </div>
            
            {
              tokenInfo.role !== 'admin' && tokenInfo.role !== 'tecnico' && (
                cantidadTickets !== null && <div className="bloque-stats"><img src="/images/ticket-lord.svg" alt="Trofeo" /><p>Tickets creados: <span>{cantidadTickets}</span></p></div>
              )
            }
          </div>
        </div>
        <div className="dashboard-content">
          {renderContent()}
        </div>
      </div>
    </main>
  );
};

export default Dashboard;
